import React from "react";
import {
  Page,
  Text,
  View,
  Document,
  StyleSheet,
  Image,
  Font,
} from "@react-pdf/renderer";
import CertBackground from "../../Admin/images/CertBg.png"; // Ensure the path is correct size 1123 x 779
import logo from "../../Admin/images/PPKM_Logo.png"; // Ensure the path is correct
import CapitalisTypOasis from "../fonts/CapitalisTypOasis.ttf";
import ArialBold from "../fonts/FontsFree-Net-arial-bold.ttf";

const API_BASE_URL =
  window.location.hostname === "localhost"
    ? "http://localhost/mobile_backend/assets/signatures/"
    : "https://www.ppkm.org.my/mobile_backend/assets/signatures/";

Font.register({
  family: "Open Sans",
  fonts: [
    {
      src: "https://cdn.jsdelivr.net/npm/open-sans-all@0.1.3/fonts/open-sans-regular.ttf",
    },
    {
      src: "https://cdn.jsdelivr.net/npm/open-sans-all@0.1.3/fonts/open-sans-600.ttf",
      fontWeight: 600,
    },
  ],
});

Font.register({
  family: "CTO",
  fonts: [
    {
      src: CapitalisTypOasis, // Path to the .ttf file
      fontWeight: "normal", // Specify the weight (e.g., normal, bold)
    },
  ],
});

Font.register({
  family: "Arial Bold",
  fonts: [
    {
      src: ArialBold, // Path to the .ttf file
      fontWeight: "bold", // Specify the weight (e.g., normal, bold)
    },
  ],
});

// Define styles for the PDF
const styles = StyleSheet.create({
  page: {
    backgroundColor: "#f4f4f4",
    padding: 20,
  },
  image: {
    width: "450px",
    height: "auto",
    padding: "30px",
    marginTop: "15px",
    alignSelf: "center",
  },
  title: {
    fontSize: 30,
    fontWeight: "bold",
    fontFamily: "CTO",
    marginBottom: 50,
  },
  subtitle: {
    fontSize: 16,
    marginBottom: 10,
  },
  content: {
    position: "relative",
    zIndex: 1,
    textAlign: "center",
    fontSize: 22,
    fontWeight: 900,
    fontFamily: "Arial Bold",
  },
  subcontent: {
    fontSize: 21,
    fontWeight: 900,
    marginBottom: 15,
    fontFamily: "Arial Bold",
  },
  content2: {
    fontSize: 12,
    fontWeight: "bold",
    marginBottom: 0,
    fontFamily: "Arial Bold",
  },
  content3: {
    fontSize: 12,
    fontWeight: 600,
    marginBottom: 10,
    fontFamily: "Arial Bold",
  },
  text: {
    fontSize: 14,
  },
  signatureContainer: {
    flexDirection: "row", // Display signatures in a row
    justifyContent: "space-evenly", // Space them evenly
    marginTop: "auto", // Push the signatures to the bottom
    paddingTop: 40, // Add space above the signatures
    marginBottom: 15,
  },
  signatureSpace: {
    width: "25%", // Adjust the width of each signature space
    borderTop: "1px solid #000", // Add a line for the signature
    paddingTop: 10, // Add space above the text
    textAlign: "center",
  },
  signatureImage: {
    width: 100, // Adjust as needed
    height: 50, // Adjust as needed
    resizeMode: "contain",
    marginBottom: 10, // Add more space below the image
    paddingBottom: 5, // Space between the image and the border
    borderBottomWidth: 1, // Thickness of the border
    borderBottomColor: "#000", // Border color
  },
  content4: {
    fontSize: 12,
    marginBottom: 5,
  },
  content5: {
    fontSize: 12,
    marginBottom: 10,
  },
});

// Create Document Component
const IndividualCert = ({
  data,
  presidentData,
  secretariatData,
}) => {
  const salutations: { [key: number]: string } = {
    0: "Mr",
    1: "Mrs",
    2: "Ms",
    3: "Dato",
    4: "Tan Sri",
    5: "Puan Sri",
    6: "Datuk Seri",
    7: "Datin Seri",
    8: "Datuk",
    9: "Datin",
    10: "Dr",
    11: "Miss",
  };

  const getSalutation = (key: number) => salutations[key] || "Unknown";
  console.log(getSalutation(data.individual_salutation)); // Output: "Dato"
  const salutation = getSalutation(data.individual_salutation);

  return (
    <Document>
      <Page size="A4" orientation="landscape" style={styles.page}>
        <Image
          style={{
            position: "absolute",
            top: 8,
            right: 8,
            bottom: 8,
            left: 8,
            objectFit: "fill",
          }}
          src={CertBackground} // Replace with your image URL
        />
        {/* Certificate Content */}
        <View style={styles.content}>
          <Image src={logo} style={styles.image} />
          <Text style={styles.title}>MEMBERSHIP CERTIFICATE</Text>
          <Text style={styles.subtitle}>THIS IS TO CERTIFY THAT</Text>
          <Text style={styles.content}>
            {salutation} {data.individual_name}
          </Text>
          <Text style={styles.content2}>
            IS AN {data.member_type_label.toUpperCase()} MEMBER OF PERSATUAN
            PENGURUSAN KOMPLEKS MALAYSIA (PPK) FOR YEAR 2013
          </Text>
          <Text style={styles.content3}>(0227-OMI-0904)</Text>
        </View>

        {/* Signature Container */}
        <View style={styles.signatureContainer}>
          <View style={styles.signatureSpace}>
            <Image
              source={`${API_BASE_URL}president.png`}
              // source={{ uri: SignaturePresident }} // If it's an external URL
              style={styles.signatureImage}
            />
            <Text style={styles.content4}>President</Text>
            <Text style={styles.content5}>{presidentData?.full_name}</Text>
          </View>
          <View style={styles.signatureSpace}>
            <Image
              source={`${API_BASE_URL}secretary.png`}
              style={styles.signatureImage}
            />
            <Text style={styles.content4}>Secretary</Text>
            <Text style={styles.content5}>{secretariatData?.full_name}</Text>
          </View>
        </View>
      </Page>
    </Document>
  );
};

export default IndividualCert;
